// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"d0fc85c5","38":"3c1fdaec","215":"39e477b2","275":"f9b8ea13","388":"181af131","397":"e1b5d335","488":"79faad5e","497":"26bb965e","519":"f6c73202","535":"0b244238","664":"e4e8f3c2","830":"b395b2d8","942":"7e3b6f5b"}[chunkId] + ".chunk.js";
};